import clsx from 'clsx';
import { renderSVG } from 'uqr';

interface TotpQrCodeProps {
  className?: string;
  dataTestId: string;
  label: string;
  otpauthUri: string;
}

export function TotpQrCode({ className, dataTestId, label, otpauthUri }: TotpQrCodeProps) {
  const svg = renderSVG(otpauthUri, { border: 2, ecc: 'M', pixelSize: 6 });
  return (
    <img
      alt={label}
      className={clsx('MfaSettingsSection__qr', className)}
      data-testid={dataTestId}
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`}
    />
  );
}
